import { EMPTY } from '@pmai/contracts';

/** Link that opens in a new tab, or "–" when not set (contract folder, charter, website). */
export function ExternalLink({ href, label }: { href: string | null; label?: string }) {
  if (!href) return <span className="text-ink-muted">{EMPTY}</span>;
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-brand-700 hover:underline">
      {label ?? href}
    </a>
  );
}
